<template>
  <div
    id="call-logs-container"
    class="page-content call-logs-container"
  >
    <template v-if="partnerCode === 'pace'">
      <total-calls />
    </template>
    <template v-else>
      <call-logs-table />
      <call-record-player v-if="!isPartnerDashboard" />
      <qa-calibration-form v-if="callLogQAData" />
      <operator-report />
      <call-summary-form />
    </template>
  </div>
</template>

<script setup lang="ts">
import { onMounted, defineAsyncComponent } from 'vue';
import { useRoute } from 'vue-router';

import util from '@/Utils/util';
import { usePartner } from '@/use/partner';
import { useDashboard } from '@/use/app';
import { callLogQAData } from '@/services/callLogs/callLogsViewModel';

const CallLogsTable = defineAsyncComponent(() => import('./CallLogs/CallLogs.vue') as any);

const QaCalibrationForm = defineAsyncComponent(() => import('./CallLogs/QaCalibrationForm.vue') as any);

const CallRecordPlayer = defineAsyncComponent(() => import('./CallLogs/CallRecordPlayer.vue') as any);

const TotalCalls = defineAsyncComponent(() => import('./CallLogs/TotalCalls.vue') as any);

const OperatorReport = defineAsyncComponent(() => import('./CallLogs/OperatorReport.vue') as any);

const CallSummaryForm = defineAsyncComponent(() => import('./CallSummary.vue') as any);

const { partnerCode } = usePartner();
const { isPartnerDashboard } = useDashboard();

onMounted(() => {
  const route = useRoute();
  const { hash } = route;

  util.moveScrollComponent(hash);
});
</script>
